import React, { useState, useRef, useEffect } from 'react';
import 'react-simple-keyboard/build/css/index.css';
import Styles from '../orders.module.scss';
import cn from 'classnames';
import { LABEL } from '../../../veriables';
import CustomKeyboard from '@components/common/CustomKeyboard/index';

const openPopUp = ({
  // maxLength = 10,
  // name,
  onSubmit,
  validate,
  isOpen,
  selected,
  setIsOpenPopUp,
  isOpenPopUp,
  discounts
}) => {
  const [keyboardType, setKeyboardType] = useState('dot');
  const ref = useRef(null);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const [inputName, setInputName] = useState('discount');
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [typed, setTyped] = useState('');


  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: ''
    });
    setTyped({
      ...typed,
      [data]: ''
    });
  };
  useEffect(() => {
    if (ref.current) {
      setEmpty('phoneNumber');
    }
  }, []);

  const closeKeyboard = () => {
    setSwipedDown(false);
  };

  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const handleSubmit = () => {
    const data = {
      ...inputs
    };
    validate(data).then(() => {
      setIsOpenPopUp(!isOpenPopUp);
      onSubmit(data);
    }).catch((err) => {
      setError(err.message);
    });
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const discount = document.querySelector('#discount');
    discount.blur();
  };
  useEffect(() => {
    if (ref.current) {
      setInputs({
        ...inputs,
        [inputName]: inputs[inputName]
      });
      ref.current.input = {
        ...inputs,
        [inputName]: inputs[inputName]
      };
    }
  }, [isSwipedDown]);

  const getStyle = () => {
    return discounts.find((e) => e.id === Number(selected))?.discountType === 1 ? Styles.currencyDollar : Styles.currencyPercent;
  };

  const onClickBtn = (e) => {
    setError('');
    setTyped(e === '{bksp}' ? { ...typed, [inputName]: typed[inputName]?.slice(0, -1) } : { ...typed, [inputName]: typed[inputName] ? typed[inputName].concat(e) : ''.concat(e) });
    const value = e === '{bksp}' ? { ...typed, [inputName]: typed[inputName]?.slice(0, -1) } : { ...typed, [inputName]: typed[inputName] ? typed[inputName].concat(e) : ''.concat(e) };
    setInputs({
      ...inputs,
      [inputName]: value[inputName]
    });
  };

  return isOpen && (
    <div>
      <div className="col-12 p-0 large-input">
        <div className={cn('col-12 p-0 my-2', inputName === 'discount' ? 'border roundedSm od-container-card-border border-color-primary' : '')}>
          <div
            style={{ top: '50%', transform: 'translateY(-50%)' }}
            className={cn('position-absolute', getStyle())}
          >
            {discounts.find((e) => e.id === Number(selected))?.discountType === 1 ? `${LABEL().CURRENCY_SYMBOL}` : '%'}
          </div>
          <input
            id="discount"
            type="text"
            name="discount"
            value={getInputValue('discount')}
            className="col-12 form-control"
            style={{ height: '10vh', fontSize: '5vh' }}
            placeholder={LABEL().DISCOUNT}
            onFocus={() => { handleBlur(); setInputName('discount'); }}
          />
          {inputs?.discount?.length > 0 && (
          <div
            role="presentation"
            className="position-absolute"
            style={{ right: '18px', top: '15px' }}
            onClick={() => { setEmpty('discount'); setInputName('discount'); }}
          >
            <i className="fa fa-times fs-24 od-text-secondary text-secondary" aria-hidden="true" />
          </div>
          )}
        </div>
        {error.length > 0 && <div className="text-center fs-12 text-primary">{error}</div>}
        <div className="col-12 row mx-0 px-0 py-2 justify-content-center align-items-center">
          <div className="col-12 px-1">
            <button disabled={!selected} className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary fs-14" type="button" onClick={() => { handleSubmit(); }}>
              <div className="fs-30">{LABEL().APPLY}</div>
            </button>
          </div>
        </div>
      </div>
      <div className={cn('p-1 background-primary od-border-secondary od-app-background-color', Styles.keyboard)}>
        {isSwipedDown && (
          <CustomKeyboard
            setKeyboardType={setKeyboardType}
            onClickBtn={(e) => onClickBtn(e)}
            type={keyboardType}
            typed={typed[inputName] || ''}
            closeKeyboard={closeKeyboard}
            btnSize="btn"
            isDot
            customClass="fs-30 background-primary od-app-background-color"
          />
        )}
      </div>
    </div>
  );
};

export default openPopUp;
